module.exports = __webpack_public_path__ + "img/4_44.36962f4b.png";